import fb from '@/services/firebase'
import { Timestamp, getDocs, getDoc, doc, updateDoc } from 'firebase/firestore'
import useDateFilter from '@/assets/lib/date_filter'
import useFirebaseQuery from '@/assets/lib/firebase_query'

export const namespaced = true

export const state = {
  sales_list: [],
  sales_loading: false
}

export const mutations = {
  SET_SALES_LOADING(state, payload) {
    state.sales_loading = payload
  },
  SET_INVENTORY_LIST(state, payload) {
    state.sales_list = payload
  },
  UPDATE_INVENTORY_LIST(state, payload) {
    state.sales_list.forEach(item => {
      const businessFound = item.businesses.findIndex(eachBusiness => eachBusiness.business_id === payload.business_id)
      if (businessFound !== -1) {
        item.businesses[businessFound].business_name = payload.business_name
        item.businesses[businessFound].owner_id = payload.owner_id
        item.new_item = true
      }
    })
  }
}

export const actions = {
  async allSalesInventory({ commit, dispatch }, payload) {
    const date_filter = useDateFilter().dateFilter(payload)
    const start_date = Timestamp.fromDate(new Date(date_filter.start_date))
    const end_date = Timestamp.fromDate(new Date(date_filter.end_date))
    const num_of_days = Timestamp.fromDate(new Date(date_filter.num_of_days))

    let sales
    if (payload.period !== 'Between Dates') {
      sales = useFirebaseQuery().multiSimpleQuery('dashboard_summary', 'sales', 'breakdown', 'updated_at', num_of_days)
    } else {
      sales = useFirebaseQuery().multiComplexQuery(
        'dashboard_summary',
        'sales',
        'breakdown',
        'updated_at',
        start_date,
        end_date
      )
    }

    // const sales = query(
    //   collection(fb.db, 'dashboard_summary', 'sales', 'breakdown'),
    //   where('updated_at', '>=', new_date)
    // )
    const querySnapshot = await getDocs(sales)
    const container = []
    if (!querySnapshot.empty) {
      querySnapshot.forEach(snapDoc => {
        const details = snapDoc.data()
        details.id = snapDoc.id
        container.push(details)
        for (let index = 0; index < snapDoc.data().businesses.length; index++) {
          const business = snapDoc.data().businesses[index]
          if (business.business_name === undefined) {
            dispatch('getBusinessDetails', {
              business_id: business.business_id,
              breakdown_id: snapDoc.id,
              business_index: index
            })
          }
        }
      })
      commit('SET_INVENTORY_LIST', container)
    } else {
      commit('SET_INVENTORY_LIST', container)
    }
  },
  async updateDashboardSummary({ state }) {
    state.sales_list.forEach(item => {
      if (item.new_item != undefined) {
        updateDoc(doc(fb.db, 'dashboard_summary', 'sales', 'breakdown', item.id), {
          businesses: item.businesses
        })
      }
    })
  },
  async getBusinessDetails({ commit }, payload) {
    const business_details = await getDoc(doc(fb.db, 'businesses', payload.business_id))
    commit('UPDATE_INVENTORY_LIST', {
      business_id: payload.business_id,
      business_name: business_details.data().business_name,
      owner_id: business_details.data().owner_id
    })
  }
}
